export enum FilterOperation {
  Equal = 'eq',
  NotEqual = 'neq',
  Or = 'or',
  LessThan = 'lt',
  LessThanEqual = 'lte',
  GreaterThan = 'gt',
  GreaterThanEqual = 'gte',
  StartsWith = 'sw',
  EndsWith = 'ew',
  Contains = 'c',
  Between = 'btw',
  // Nullable variants of above operators - Using them will filter but include null values
  LessThanEqualNullable = 'lten',
  GreaterThanEqualNullable = 'gten',
}

export enum RowState {
  New = 0,
  Deleted = 1,
  Updated = 2,
  Unchanged = 3,
}

export enum InvoiceStatus {
  Inbound = 0,
  ToBeProcessed = 1,
  ToBeChecked = 2,
  Processed = 3,
  Unknown = 4,
}

export interface CurrencyAmount {
  currency: string;
  amount: number;
  vatAmount: number;
}

export interface Boundary {
  min: number | Date;
  max: number | Date;
}

export interface PagedResultMetadata<T> {
  totalNumberOfInvoice: number;
  filters: Record<keyof T, Boundary>;
  currencyAmounts: CurrencyAmount[];
  currencies: string[];
}

export interface PagedRequest {
  pageIndex: number;
  pageSize: number;
  sort?: string;
  direction?: string;
  keys?: string;
  operations?: string;
  values?: string;
  searchCriterias?: {
    key: string;
    operation: string;
    value: string;
  }[];
}

export interface PagedResponse<T> {
  pageSize?: number | null;
  pageIndex?: number | null;
  totalPages?: number | null;
  totalRecords?: number | null;
  data?: T[] | null;
}
